export default "__VITE_ASSET__D4FfWuP6__"